/* ==========================================================================
   Past Performance.

   ⚠️  Scope narratives below are drawn ONLY from client-approved copy in
   Bethel Content1.docx. Contract numbers, periods of performance, dollar
   values and role (prime vs. sub) are `null` — they are contract facts and
   must come from the client. Null fields do not render.
   ========================================================================== */

import treasury from '../assets/img/treasury.png';
import accenture from '../assets/img/accenture.png';
import irs from '../assets/img/irs.png';

export const engagements = [
  {
    id: 'treasury',
    client: 'U.S. Department of the Treasury',
    logo: treasury,
    logoAlt: 'U.S. Department of the Treasury',
    /* Optical scale. The Treasury mark is a circular seal; at the same pixel
       height as a wide wordmark it reads noticeably smaller and lighter, so
       it is scaled up to match. Wordmarks scale down slightly. */
    logoScale: 1.34,
    href: 'https://home.treasury.gov/',
    sector: 'Federal — Financial',
    headline: 'Cybersecurity delivery oversight across multiple programs',
    scope:
      'Led and continues to support the cybersecurity delivery arm of multiple projects at the Treasury Department, providing oversight of security deliverables and supporting application and infrastructure delivery on high-visibility and sensitive engagements.',
    highlights: [
      'Oversight of security deliverables across multiple concurrent programs',
      'Application and infrastructure delivery support on sensitive engagements',
      'Mapping of program security requirements to NIST SP 800-53 controls',
    ],
    role: null,          // TODO(client): prime or subcontractor
    period: null,        // TODO(client): period of performance
    contractNumber: null,// TODO(client)
  },
  {
    id: 'irs',
    client: 'Internal Revenue Service',
    logo: irs,
    logoAlt: 'Internal Revenue Service',
    logoScale: 1,
    href: 'https://www.irs.gov/',
    sector: 'Federal — Tax Administration',
    headline: 'Lead solution architect, tax system infrastructure modernization',
    scope:
      'Provided strategic and full lifecycle management support for the modernization of IRS tax system infrastructure portals, network, virtualization, server management and data integration, leveraging existing platforms and technology.',
    highlights: [
      'Full lifecycle modernization of infrastructure portals and networks',
      'Virtualization, server management and data integration',
      'Application integration, testing and production deployment support',
    ],
    role: null,
    period: null,
    contractNumber: null,
  },
  {
    id: 'accenture-federal',
    client: 'Accenture Federal Services',
    logo: accenture,
    logoAlt: 'Accenture Federal Services',
    logoScale: 0.92,
    href: 'https://www.accenture.com/us-en',
    sector: 'Prime Contractor — Teaming',
    headline: 'Delivery partner on federal technology programs',
    scope:
      'Supported federal technology delivery as a teaming partner, contributing cybersecurity, change management and enterprise IT capability alongside prime contractor teams.',
    highlights: [
      'Subcontract administration and management',
      'Specialist cybersecurity and change management capability',
      'Aligned delivery with prime contractor programs and standards',
    ],
    role: null,
    period: null,
    contractNumber: null,
  },
];

/* Core competencies and differentiators — used by both the Past Performance
   page and the Capability Statement. Sourced from "Why choose us?" in
   Bethel Content1.docx. */
export const differentiators = [
  {
    title: 'Our People',
    body: 'Senior practitioners with direct federal delivery experience, not generalists learning the mission on your contract.',
  },
  {
    title: 'Performance-Based Processes',
    body: 'Delivery measured against defined outcomes and reported as trends leadership can act on.',
  },
  {
    title: 'IT Cybersecurity Domain Expertise',
    body: 'Full-cycle A&A, continuous monitoring and Zero Trust architecture across FISMA, FedRAMP and NIST RMF.',
  },
  {
    title: 'IT Change Management Domain Expertise',
    body: 'Change and configuration management practice built for environments where an unplanned change is an incident.',
  },
  {
    title: 'Sub Contract Administration and Management',
    body: 'An experienced teaming partner — straightforward to add to a prime team and to manage once there.',
  },
  {
    title: 'Innovative Talent Sourcing',
    body: 'Cleared and specialist talent sourced against real program requirements and surge timelines.',
  },
];
